var _path, _path2, _circle, _circle2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSale = function SvgSale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.55 9.187 4.59-5.929 6.261 4.127 1.74 10.474L7.29 19.662 5.55 9.187Z",
    fill: "#FFBCC4",
    stroke: "#FFBCC4",
    strokeWidth: 1.179,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m4.715 8.24 5.5-5.097 5.5 5.096v10.618h-11V8.24Z",
    fill: "#FFA0CC",
    stroke: "#FFA0CC",
    strokeWidth: 1.179,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.179,
    cy: 14.536,
    r: 1.179,
    stroke: "#fff",
    strokeWidth: 1.179
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.25,
    cy: 10.607,
    r: 1.179,
    stroke: "#fff",
    strokeWidth: 1.179
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m12.572 9.429-4.715 6.285",
    stroke: "#fff",
    strokeWidth: 1.179,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.214 5.5a.786.786 0 1 1 0 1.571.786.786 0 0 1 0-1.571Z",
    fill: "#FFA0CC"
  })));
};

export default SvgSale;